import { render } from "./AllCustomers.vue?vue&type=template&id=7efba84c"
import script from "./AllCustomers.vue?vue&type=script&lang=js"
export * from "./AllCustomers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__